import React, { useEffect } from "react";
import Chart from "react-apexcharts";

interface LeaveChartProps {
  title: any;
  balance: number | string; // from API, could be string
  availed: number | string;
  total: number | string;
}

const LeaveChart: React.FC<LeaveChartProps> = ({
  title,
  balance,
  availed,
  total,
}) => {
  // Convert to numbers safely
  const numericBalance = parseFloat(balance as any) || 0;
  const numericAvailed = parseFloat(availed as any) || 0;
  const numericTotal = parseFloat(total as any) || 0;

  useEffect(() => {}, [title, numericBalance, numericAvailed, numericTotal]);

  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "donut",
    },
    labels: ["Availed", "Balance"],
    colors: ["#5f66d4", "#a4a9f5"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      labels: {
        colors: "#000",
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "50%",
          labels: {
            show: true,
            value: {
              show: true,
              fontSize: "16px",
              color: "#111",
              // formatter: () => `${numericBalance.toFixed(2)}/${numericTotal.toFixed(2)}`,
              formatter: () => `${numericTotal.toFixed(1)}`,
            },
            name: {
              show: false,
              //   fontSize: "14px",
              //   color: "#555",
            },
            total: {
              show: true,
              //   label: "Total",
              fontSize: "13px",
              color: "#777",
              // formatter: () => `${numericBalance.toFixed(2)}/${numericTotal.toFixed(2)}`,
              formatter: () => `${numericTotal.toFixed(1)}`,
            },
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
  };

  const series = [numericAvailed, numericBalance];

  return (
    <div style={{ width: 250, textAlign: "center" }}>
      <>{title}</>
      <Chart options={options} series={series} type="donut" height={250} />
    </div>
  );
};

export default LeaveChart;
